export const simpleSound = () => {
  const audio = new Audio(require('@/assets/sounds/notify.mp3'))
  audio.play()
}
